import moment from "moment"
import configs from "@/configs";

  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function getCurrentUserRoleId(store) {
    const authState = store && store.state ? store.state.authentication : null;
    const user = authState ? authState.user : null;
    if (user && user.roleid) {
      return Number(user.roleid);
    }
    try {
      const persistedUser = localStorage.getItem('user');
      const parsedUser = persistedUser ? JSON.parse(persistedUser) : null;
      return parsedUser && parsedUser.roleid ? Number(parsedUser.roleid) : 0;
    } catch (error) {
      return 0;
    }
  }

  export function hasLegacyRoleAccess(userRoleId, roleId) {
    if (!roleId) {
      return true;
    }
    const roleType = _.find(configs.ROLES, { value: Number(userRoleId) });
    return !!(roleType && (roleType.modules & roleId));
  }

  export function hasFeatureAccess(store, featureKey, minimum = 1) {
    if (!featureKey) {
      return true;
    }
    const permState = store && store.state ? store.state.permission : null;
    const matrix = permState && permState.matrix ? permState.matrix : {};
    const userRole = getCurrentUserRoleId(store);
    const featureMatrix = matrix[featureKey];

    if (!userRole) {
      return false;
    }

    if (!featureMatrix || typeof featureMatrix !== 'object') {
      console.warn(`[permission] Missing matrix config for feature "${featureKey}"`);
      return false;
    }

    return Number(featureMatrix[userRole] || 0) >= minimum;
  }

  export function hasFeatureEditPermission(store, featureKey) {
    return hasFeatureAccess(store, featureKey, 2);
  }

  export function buildBreadcrumb(routeName, routePath, pId, title, menu, paths) {
    let breadcrumbs = [];
    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: item.title,
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, title, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: item.title,
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: title || `${child.title} (#${pId})`,
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
